import { withInstall } from '@ll-plus/utils'

import IconBase from './src/icon-base.vue'

export const LlIconBase = withInstall(IconBase)
export default LlIconBase
export * from './src/icon-base'

declare module 'vue' {
  export interface GlobalComponents {
    LlIconBase: typeof IconBase
  }
}
